module.exports = __webpack_public_path__ + "media/38.41a98714.mp3";